import { TimelineSpan } from './TimelineSpan'

export const redisSpanIsMissingKeyAnnotation = (span: TimelineSpan): boolean => {
    if (span.cat !== 'redis' || !span.annotations) {
        return false
    }

    // if redis.key is present, everything is fine
    if ('redis.key' in span.annotations) {
        return false
    }

    if (!('redis.command' in span.annotations)) {
        return false
    }

    const command = span.annotations['redis.command'].toUpperCase()

    return command in redisCommandsWithAKey
}

// ref https://github.com/tideways/php-extension-next/blob/master/src/redis_key_positions.gperf
const redisCommandsWithAKey: { [command: string]: true } = {
    APPEND: true,
    'BF.ADD': true,
    'BF.CARD': true,
    'BF.DEBUG': true,
    'BF.EXISTS': true,
    'BF.INFO': true,
    'BF.INSERT': true,
    'BF.LOADCHUNK': true,
    'BF.MADD': true,
    'BF.MEXISTS': true,
    'BF.RESERVE': true,
    'BF.SCANDUMP': true,
    BITCOUNT: true,
    BITFIELD: true,
    BITFIELD_RO: true,
    BITOP: true,
    BITPOS: true,
    BLMOVE: true,
    BLPOP: true,
    BRPOP: true,
    BRPOPLPUSH: true,
    BZPOPMAX: true,
    BZPOPMIN: true,
    'CF.ADD': true,
    'CF.ADDNX': true,
    'CF.COMPACT': true,
    'CF.COUNT': true,
    'CF.DEBUG': true,
    'CF.DEL': true,
    'CF.EXISTS': true,
    'CF.INFO': true,
    'CF.INSERT': true,
    'CF.INSERTNX': true,
    'CF.LOADCHUNK': true,
    'CF.MEXISTS': true,
    'CF.RESERVE': true,
    'CF.SCANDUMP': true,
    'CMS.INCRBY': true,
    'CMS.INFO': true,
    'CMS.INITBYDIM': true,
    'CMS.INITBYPROB': true,
    'CMS.MERGE': true,
    'CMS.QUERY': true,
    COPY: true,
    DECR: true,
    DECRBY: true,
    DEL: true,
    DUMP: true,
    EXISTS: true,
    EXPIRE: true,
    EXPIREAT: true,
    EXPIRETIME: true,
    'FT.ADD': true,
    'FT.AGGREGATE': true,
    'FT.ALIASADD': true,
    'FT.ALIASDEL': true,
    'FT.ALIASUPDATE': true,
    'FT.ALTER': true,
    'FT.CREATE': true,
    'FT.CURSOR': true,
    'FT.DEL': true,
    'FT.DROP': true,
    'FT.DROPINDEX': true,
    'FT.EXPLAIN': true,
    'FT.EXPLAINCLI': true,
    'FT.GET': true,
    'FT.INFO': true,
    'FT.MGET': true,
    'FT.PROFILE': true,
    'FT.SAFEADD': true,
    'FT.SEARCH': true,
    'FT.SPELLCHECK': true,
    'FT.SUGADD': true,
    'FT.SUGDEL': true,
    'FT.SUGGET': true,
    'FT.SUGLEN': true,
    'FT.SYNADD': true,
    'FT.SYNDUMP': true,
    'FT.SYNUPDATE': true,
    'FT.TAGVALS': true,
    'FT._ALIASADDIFNX': true,
    'FT._ALIASDELIFX': true,
    'FT._ALTERIFNX': true,
    'FT._CREATEIFNX': true,
    'FT._DROPIFX': true,
    'FT._DROPINDEXIFX': true,
    GEOADD: true,
    GEODIST: true,
    GEOHASH: true,
    GEOPOS: true,
    GEORADIUS: true,
    GEORADIUSBYMEMBER: true,
    GEORADIUSBYMEMBER_RO: true,
    GEORADIUS_RO: true,
    GEOSEARCH: true,
    GEOSEARCHSTORE: true,
    GET: true,
    GETBIT: true,
    GETDEL: true,
    GETEX: true,
    GETRANGE: true,
    GETSET: true,
    HDEL: true,
    HEXISTS: true,
    HEXPIRE: true,
    HEXPIREAT: true,
    HEXPIRETIME: true,
    HGET: true,
    HGETALL: true,
    HINCRBY: true,
    HINCRBYFLOAT: true,
    HKEYS: true,
    HLEN: true,
    HMGET: true,
    HMSET: true,
    HPERSIST: true,
    HPEXPIRE: true,
    HPEXPIREAT: true,
    HPEXPIRETIME: true,
    HPTTL: true,
    HRANDFIELD: true,
    HSCAN: true,
    HSET: true,
    HSETNX: true,
    HSTRLEN: true,
    HTTL: true,
    HVALS: true,
    INCR: true,
    INCRBY: true,
    INCRBYFLOAT: true,
    'JSON.ARRAPPEND': true,
    'JSON.ARRINDEX': true,
    'JSON.ARRINSERT': true,
    'JSON.ARRLEN': true,
    'JSON.ARRPOP': true,
    'JSON.ARRTRIM': true,
    'JSON.CLEAR': true,
    'JSON.DEBUG': true,
    'JSON.DEL': true,
    'JSON.FORGET': true,
    'JSON.GET': true,
    'JSON.MERGE': true,
    'JSON.MGET': true,
    'JSON.MSET': true,
    'JSON.NUMINCRBY': true,
    'JSON.NUMMULTBY': true,
    'JSON.NUMPOWBY': true,
    'JSON.OBJKEYS': true,
    'JSON.OBJLEN': true,
    'JSON.RESP': true,
    'JSON.SET': true,
    'JSON.STRAPPEND': true,
    'JSON.STRLEN': true,
    'JSON.TOGGLE': true,
    'JSON.TYPE': true,
    LCS: true,
    LINDEX: true,
    LINSERT: true,
    LLEN: true,
    LMOVE: true,
    LPOP: true,
    LPOS: true,
    LPUSH: true,
    LPUSHX: true,
    LRANGE: true,
    LREM: true,
    LSET: true,
    LTRIM: true,
    MGET: true,
    MIGRATE: true,
    MOVE: true,
    MSET: true,
    MSETNX: true,
    PERSIST: true,
    PEXPIRE: true,
    PEXPIREAT: true,
    PEXPIRETIME: true,
    PFADD: true,
    PFCOUNT: true,
    PFDEBUG: true,
    PFMERGE: true,
    PSETEX: true,
    PTTL: true,
    RENAME: true,
    RENAMENX: true,
    RESTORE: true,
    'RESTORE-ASKING': true,
    RPOP: true,
    RPOPLPUSH: true,
    RPUSH: true,
    RPUSHX: true,
    SADD: true,
    SCARD: true,
    SDIFF: true,
    SDIFFSTORE: true,
    SET: true,
    SETBIT: true,
    SETEX: true,
    SETNX: true,
    SETRANGE: true,
    SINTER: true,
    SINTERSTORE: true,
    SISMEMBER: true,
    SMEMBERS: true,
    SMISMEMBER: true,
    SMOVE: true,
    SORT: true,
    SORT_RO: true,
    SPOP: true,
    SPUBLISH: true,
    SRANDMEMBER: true,
    SREM: true,
    SSCAN: true,
    SSUBSCRIBE: true,
    STRLEN: true,
    SUBSTR: true,
    SUNION: true,
    SUNIONSTORE: true,
    SUNSUBSCRIBE: true,
    'TDIGEST.ADD': true,
    'TDIGEST.BYRANK': true,
    'TDIGEST.BYREVRANK': true,
    'TDIGEST.CDF': true,
    'TDIGEST.CREATE': true,
    'TDIGEST.INFO': true,
    'TDIGEST.MAX': true,
    'TDIGEST.MERGE': true,
    'TDIGEST.MIN': true,
    'TDIGEST.QUANTILE': true,
    'TDIGEST.RANK': true,
    'TDIGEST.RESET': true,
    'TDIGEST.REVRANK': true,
    'TDIGEST.TRIMMED_MEAN': true,
    'TOPK.ADD': true,
    'TOPK.COUNT': true,
    'TOPK.INCRBY': true,
    'TOPK.INFO': true,
    'TOPK.LIST': true,
    'TOPK.QUERY': true,
    'TOPK.RESERVE': true,
    TOUCH: true,
    'TS.ADD': true,
    'TS.ALTER': true,
    'TS.CREATE': true,
    'TS.CREATERULE': true,
    'TS.DECRBY': true,
    'TS.DEL': true,
    'TS.DELETERULE': true,
    'TS.GET': true,
    'TS.INCRBY': true,
    'TS.INFO': true,
    'TS.MADD': true,
    'TS.RANGE': true,
    'TS.REVRANGE': true,
    TTL: true,
    TYPE: true,
    UNLINK: true,
    WATCH: true,
    XACK: true,
    XADD: true,
    XAUTOCLAIM: true,
    XCLAIM: true,
    XDEL: true,
    XLEN: true,
    XPENDING: true,
    XRANGE: true,
    XREVRANGE: true,
    XSETID: true,
    XTRIM: true,
    ZADD: true,
    ZCARD: true,
    ZCOUNT: true,
    ZDIFFSTORE: true,
    ZINCRBY: true,
    ZINTERSTORE: true,
    ZLEXCOUNT: true,
    ZMSCORE: true,
    ZPOPMAX: true,
    ZPOPMIN: true,
    ZRANDMEMBER: true,
    ZRANGE: true,
    ZRANGEBYLEX: true,
    ZRANGEBYSCORE: true,
    ZRANGESTORE: true,
    ZRANK: true,
    ZREM: true,
    ZREMRANGEBYLEX: true,
    ZREMRANGEBYRANK: true,
    ZREMRANGEBYSCORE: true,
    ZREVRANGE: true,
    ZREVRANGEBYLEX: true,
    ZREVRANGEBYSCORE: true,
    ZREVRANK: true,
    ZSCAN: true,
    ZSCORE: true,
    ZUNIONSTORE: true,
}
